import { Fragment, useMemo } from 'react';

import { Typography } from '@mui/material';

import { column_heading, time_slots_styles } from './styles';
import { generateTimeSlots } from './utils';

const TimeSlots = ({ startHour = 7, endHour = 22 }) => {
  const timeSlots = useMemo(() => {
    return generateTimeSlots(startHour, endHour);
  }, [startHour, endHour]);

  return (
    <Fragment>
      <Typography sx={column_heading} variant="body2">
        Time
      </Typography>
      {timeSlots.map((slot, index) => (
        <Typography key={index} sx={time_slots_styles} component="p">
          {slot.time12.replace(':00 ', ' ')}
        </Typography>
      ))}
    </Fragment>
  );
};

export default TimeSlots;
